import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import ReactMarkdown from "react-markdown"
import Seo from "../components/Seo"
import ShareButtons from "../components/share-buttons"
import readingTime from "reading-time"
import { Col, Container, Row } from "react-bootstrap"
import NavBlog from "../components/NavBlog"
import moment from "moment"
import SamePosts from "../components/SamePosts"
import RelatedPosts from "../components/RelatedPosts"
import FooterBanner from "../components/FooterBanner"
import BlogFooterBanner from "../components/BlogFooterBanner"
import PopularCategory from "../components/PopularCategory"
import { FaFileDownload } from "react-icons/fa"
import gfm from "remark-gfm"

const BlogTemplate = ({ data }) => {
  const url = typeof window !== "undefined" ? window.location.href : ""
  const {
    blog: {
      content,
      author,
      Image: {
        localFile: { publicURL },
      },
      title,
      shortDescription,
      date,
      category,
      authorDescription,
      authorImage,
      download_file,
      download_text,
    },
  } = data

  return (
    <Layout>
      <Seo
        Sitetitle={title}
        description={shortDescription}
        Blogimage={publicURL}
      />
      <NavBlog />
      <section className="banner blog-banner">
        <div className="hero-img-container">
          <div className="color-overlay"></div>
          <img src={publicURL} alt={title} />
        </div>
        <Container>
          <div className="banner-det">
            <h1>{category}</h1>
            <h2>{title}</h2>
            <div className="d-flex sm-details my-4">
              <h5>{author}</h5>
              <h5>{moment(date).format("MMM M, YYYY")}</h5>
              <h5>{readingTime(content).text}</h5>
            </div>
          </div>
        </Container>
      </section>
      <Container className="my-5">
        <Row>
          <Col lg={2} md={12}>
            <ShareButtons
              link={`https://undorm.com${publicURL}`}
              url={url}
              title={title}
              description={shortDescription}
            />
          </Col>
          <Col lg={7} md={12}>
            <article className="blog-content">
              <ReactMarkdown remarkPlugins={[gfm]} className="content">
                {content}
              </ReactMarkdown>
              {download_file !== null && (
                <div className="downloads">
                  <a
                    className="d-flex align-items-center justify-content-center"
                    href={download_file?.localFile?.publicURL}
                  >
                    <FaFileDownload className="download-icon" />
                    {download_text && (
                      <h3 className="colorr ms-3">{download_text}</h3>
                    )}
                  </a>
                </div>
              )}
            </article>
          </Col>
          <Col lg={3} md={12}>
            <PopularCategory category={category} number={12} />
          </Col>
        </Row>
      </Container>
      <BlogFooterBanner />
      <Container>
        <div className="d-flex author-det align-items-start align-items-lg-center border">
          <div className="img">
            <img src={authorImage[0]?.localFile?.publicURL} alt="" />
          </div>
          <div className="a-det">
            <p className="rb">AUTHORED BY {author.toUpperCase()}</p>
            <p>{authorDescription}</p>
          </div>
        </div>
        <RelatedPosts category={category} />
        <SamePosts category={category} />
      </Container>
      <FooterBanner />
    </Layout>
  )
}

export const query = graphql`
  query GetSingleBlog($slug: String) {
    blog: strapiBlogs(slug: { eq: $slug }) {
      Image {
        localFile {
          publicURL
        }
      }
      content
      author
      title
      date
      category
      authorDescription
      shortDescription
      authorImage {
        localFile {
          publicURL
        }
      }
      download_file {
        localFile {
          publicURL
        }
      }
      download_text
    }
  }
`

export default BlogTemplate
